import Api from "./api.service";
import { decamelizeKeys, decamelize } from "humps";
import { get, isEmpty, cloneDeep } from "lodash";

const decamelizedStatus = params => {
  if (isEmpty(get(params, "filter.status"))) return params;
  params.filter.status = decamelize(params.filter.status);
  return params;
};

export class InternalInvoices {
  static all(tenantSlug, params) {
    const requestParams = decamelizeKeys(decamelizedStatus(cloneDeep(params)));
    requestParams.include = "customer";
    return Api.get(`api/v1/tenants/${tenantSlug}/internal_invoices`, { params: requestParams });
  }

  static allIds(tenantSlug, params) {
    const requestParams = decamelizeKeys(decamelizedStatus(cloneDeep({ filter: params })));

    return Api.get(`api/v1/tenants/${tenantSlug}/internal_invoices`, {
      params: {
        ...requestParams,
        fields: {
          internal_invoices: "id"
        }
      }
    });
  }

  static approve(tenantSlug, id, params = {}) {
    return Api.patch(`api/v1/tenants/${tenantSlug}/internal_invoices/${id}/approve`, decamelizeKeys(params));
  }

  static delete(tenantSlug, id, params = {}) {
    return Api.delete(`api/v1/tenants/${tenantSlug}/internal_invoices/${id}`, decamelizeKeys(params));
  }

  static close(tenantSlug, id, params = {}) {
    return Api.patch(`api/v1/tenants/${tenantSlug}/internal_invoices/${id}/close`, decamelizeKeys(params));
  }

  static pay(tenantSlug, id, params = {}) {
    return Api.patch(`api/v1/tenants/${tenantSlug}/internal_invoices/${id}/pay`, decamelizeKeys(params));
  }

  static export(tenantSlug, ids, params) {
    return Api.post(`api/v1/tenants/${tenantSlug}/internal_invoices/internal_csv`, {
      invoice_slugs: ids,
      ...decamelizeKeys(params)
    });
  }

  static netsuiteApiExport(tenantSlug, ids) {
    return Api.post(`api/v1/tenants/${tenantSlug}/internal_invoices/netsuite_api_export`, {
      invoice_slugs: ids
    });
  }

  static verifyPayment(tenantSlug, ids, params) {
    return Api.post(`api/v1/tenants/${tenantSlug}/internal_invoices/verify_payment_status`, {
      invoice_slugs: ids,
      ...params
    });
  }

  static promote(tenantSlug, params) {
    return Api.post(`api/v1/tenants/${tenantSlug}/internal_invoices/promote`, decamelizeKeys(params));
  }

  static totalNumberOfInvoices(tenantSlug, params) {
    const requestParams = decamelizeKeys(decamelizedStatus(cloneDeep({ filter: params.filter })));

    return Api.get(`api/v1/tenants/${tenantSlug}/internal_invoices/total_number_of_invoices`, {
      params: { ...requestParams }
    });
  }
}

const InternalInvoicesService = Object.freeze(InternalInvoices);
export default InternalInvoicesService;
